import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  // Stati di caricamento separati
  const [loadingImg, setLoadingImg] = useState(false);
  const [loadingText, setLoadingText] = useState(false);
  const [loadingSong, setLoadingSong] = useState(false);

  // Stati per l’immagine
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [prompt, setPrompt] = useState('');
  const [style, setStyle] = useState(undefined);

  // Stati per il testo (chatbot)
  const [newPrompt, setNewPrompt] = useState('');
  const [apiResponse, setApiResponse] = useState('');

  // Stati per la canzone
  const [lyrics, setLyrics] = useState('');
  const [audioFile, setAudioFile] = useState(null);
  const [songResponse, setSongResponse] = useState('');

  const styles = [
    undefined,
    "Cinematic",
    "Disney Character",
    "Digital Art",
    "Photographic (Default)",
    "Fantasy Art",
    "Neonpunk",
    "Enhance",
    "Comic Book",
    "Lowpoly",
    "Line Art"
  ];

  const handleFileChange = (event) => setFile(event.target.files[0]);
  const handlePromptChange = (event) => setPrompt(event.target.value);
  const handleStyleChange = (event) => setStyle(event.target.value);

  const handleAudioChange = (event) => setAudioFile(event.target.files[0]);
  const handleLyricsChange = (event) => setLyrics(event.target.value);

  // GENERAZIONE IMMAGINE
  const handleSubmit = async () => {
    if (!file || !prompt) {
      console.error('File e prompt sono obbligatori');
      return;
    }
    setLoadingImg(true); // avvia caricamento
    const formData = new FormData();
    formData.append('file', file);
    formData.append('prompt', prompt);
    formData.append('style', style);

    try {
      const response = await axios.post(
        'https://demo-photo-ai-574969884775.europe-west1.run.app/generate-img',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      setImageUrl(response.data);
    } catch (error) {
      console.error('Errore durante la generazione/upload dell’immagine:', error);
    } finally {
      setLoadingImg(false); // fine caricamento
    }
  };

  const handleReset = () => {
    setFile(null);
    setPrompt('');
    setStyle(undefined);
    setImageUrl('');
  };

  // GENERAZIONE TESTO
  const handleApiCall = async () => {
    setLoadingText(true); // avvia caricamento
    try {
      const response = await axios.post(
        'https://demo-photo-ai-574969884775.europe-west1.run.app/generate-text',
        { prompt: newPrompt }
      );
      setApiResponse(response.data);
    } catch (error) {
      console.error('Errore nella chiamata alla nuova API:', error);
      setApiResponse('Errore: ' + error.message);
    } finally {
      setLoadingText(false); // fine caricamento
    }
  };

  // GENERAZIONE CANZONE
  const handleSongUpload = async () => {
    if (!lyrics || !audioFile) {
      console.error('Lyrics e file audio sono obbligatori');
      return;
    }
    setLoadingSong(true); // avvia caricamento
    const formData = new FormData();
    formData.append('lyrics', lyrics);
    formData.append('file', audioFile);
    console.log(lyrics)
    try {
      const response = await axios.post(
        'https://demo-photo-ai-574969884775.europe-west1.run.app/generate-music',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      setSongResponse(response.data);
    } catch (error) {
      console.error('Errore nella generazione della canzone:', error);
      setSongResponse('Errore: ' + error.message);
    } finally {
      setLoadingSong(false); // fine caricamento
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Prima colonna: GENERAZIONE IMMAGINE */}
      <div 
        className="app-container" 
        style={{ flex: 1, overflowY: 'auto', maxHeight: '100vh', borderRight: '1px solid #ccc', padding: '20px', position: 'relative' }}
      >
        {/* Overlay di caricamento per l’immagine */}
        {loadingImg && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}

        {imageUrl ? (
          <div className="image-container">
            <img src={imageUrl} alt="Generated" className="generate-img" />
            <button onClick={handleReset} className="submit-button">Torna indietro</button>
          </div>
        ) : (
          <div className="input-container">
            <label className="text-label">
              Prompt (obbligatorio):
              <input
                type="text"
                value={prompt}
                onChange={handlePromptChange}
                className="text-input"
                required
              />
            </label>
            <label className="text-label">
              Stile:
              <select value={style} onChange={handleStyleChange} className="dropdown">
                {styles.map((s) => (<option key={s} value={s}>{s}</option>))}
              </select>
            </label>
            <label className="file-label">
              Inserisci la tua foto:
              <input type="file" onChange={handleFileChange} className="file-input" />
            </label>
            <button onClick={handleSubmit} className="submit-button" disabled={!prompt}>Submit</button>
          </div>
        )}
      </div>

      {/* Seconda colonna: GENERAZIONE TESTO */}
      <div 
        className="app-container" 
        style={{ flex: 1, overflowY: 'auto', maxHeight: '100vh', borderRight: '1px solid #ccc', padding: '20px', position: 'relative' }}
      >
        {/* Overlay di caricamento per il testo */}
        {loadingText && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}

        <div style={{ flex: 1, padding: '20px', display: 'flex', flexDirection: 'column' }}>
          <h3>Mistral chatbot</h3>
          <textarea
            value={newPrompt}
            onChange={(e) => setNewPrompt(e.target.value)}
            placeholder="Scrivi qui il tuo prompt..."
            className='textarea-input'
          />
          <button onClick={handleApiCall} className="submit-button">Invio</button>
          <h3>Risposta</h3>
          <textarea value={apiResponse} readOnly className='textarea-input' />
        </div>
      </div>

      {/* Terza colonna: GENERAZIONE CANZONE */}
      <div
  style={{
    flex: 1,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }}
>
  {/* Overlay di caricamento per la canzone */}
  {loadingSong && (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
    </div>
  )}

  <h3>Genera una canzone</h3>
  <textarea
    value={lyrics}
    onChange={handleLyricsChange}
    placeholder="Inserisci le lyrics..."
    className="textarea-input"
  />
  <label className="file-label">
    Carica il file audio:
    <input
      type="file"
      accept=".mp3,.wav"
      onChange={handleAudioChange}
      className="file-input"
    />
  </label>
  <button onClick={handleSongUpload} className="submit-button">
    Genera canzone
  </button>

  {/* Se abbiamo un URL di risposta, mostriamo il player audio */}
  {songResponse && (
    <div style={{ marginTop: '20px' }}>
      <h3>Ascolta la canzone generata:</h3>
      <audio
        controls
        src={songResponse}
        style={{ width: '100%' }}
      >
        Il tuo browser non supporta l’elemento audio.
      </audio>
    </div>
  )}
</div>
    </div>
  );
}

export default App;
